module.exports = __webpack_public_path__ + "static/media/1.9e60ca9e.jpg";